import React, { Component } from 'react';
import { ScrollView, Dimensions } from 'react-native';

import { find as _find, isEqual as _isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import CurrentPlan from './CurrentPlan';
import {
  getDaysArray,
  isValidCurrentPlan,
  getDateBarNumber,
  AddOnsDurationEnum,
  today,
} from './helpers';
import styles from './Timeline.Styles';
import TimelineAddOnsList from './TimelineAddOnsList';
import TimelineBars from './TimelineBars';

const SLOT = Dimensions.get('window').width / 6;

const isMonthlyViewTimeline = data => {
  // Day view   => At least one daily addOn is found
  // Month view => No daily addOns found
  const foundDailyAddon = _find(data, element => {
    return element.duration == AddOnsDurationEnum.DAY;
  });
  return foundDailyAddon === undefined;
};

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.timelineBarsScrollViewRef = React.createRef();
    this.state = {
      dates: [],
      isMonthView: true,
    };
  }

  componentDidMount() {
    this.getTimelineDays();
  }
  componentDidUpdate(prevProps) {
    const { data, currentPlan } = this.props;

    const { data: prevData, currentPlan: prevCurentPlan } = prevProps;

    const isAddonsDataChanged = !_isEqual(data, prevData);
    const isCurrentPlanChanged = !_isEqual(currentPlan, prevCurentPlan);

    if (isAddonsDataChanged || isCurrentPlanChanged) {
      this.getTimelineDays();
    }
  }
  getTimelineDays = () => {
    const { data, currentPlan } = this.props;

    const isMonthView = isMonthlyViewTimeline(data);

    const dates = getDaysArray(data, isMonthView, currentPlan);
    this.setState({ dates, isMonthView });
  };
  animateToToday = () => {
    const { dates } = this.state;
    // calculating the bar number for today to animate to it.
    const todayBarNumber = getDateBarNumber(dates, {
      date: today,
    });
    setTimeout(() => {
      this.timelineBarsScrollViewRef.current &&
        this.timelineBarsScrollViewRef.current.scrollTo({
          x: (todayBarNumber - 2.5) * SLOT,
          animated: true,
        });
    }, 0.1);
  };
  RefreshTimeLine = () => {
    if (this.props.isTimeLineRefreshed) {
      this.animateToToday();
    }
  };
  renderTimelinePlayground = () => {
    const { data, currentPlan, images, onItemPress, currentPlanIconName, renewableAddonIconName } =
      this.props;
    const { dates, isMonthView } = this.state;
    // AddonHeight + space after
    const timeLinePlaygroundHeight = (data.length + 3) * (SLOT + 20);
    return (
      <ScrollView
        nestedScrollEnabled
        bounces={false}
        contentContainerStyle={styles.timelineBarsScrollView(timeLinePlaygroundHeight)}
      >
        <TimelineAddOnsList
          onItemPress={onItemPress}
          slot={SLOT}
          isMonthView={isMonthView}
          images={images}
          data={data}
          currentPlan={currentPlan}
          dates={dates}
        />

        <TimelineBars
          slot={SLOT}
          currentPlan={currentPlan}
          data={data}
          isMonthView={isMonthView}
          dates={dates}
        />
        {isValidCurrentPlan(currentPlan) && (
          <CurrentPlan
            currentPlanIconName={currentPlanIconName}
            renewableAddonIconName={renewableAddonIconName}
            slot={SLOT}
            data={data}
            isMonthView={isMonthView}
            currentPlan={currentPlan}
            positionTop={70}
            images={images}
            dates={dates}
          />
        )}
      </ScrollView>
    );
  };

  render() {
    return (
      <ScrollView
        horizontal
        ref={this.timelineBarsScrollViewRef}
        bounces={false}
        showsHorizontalScrollIndicator={false}
      >
        {this.RefreshTimeLine()}
        {this.renderTimelinePlayground()}
      </ScrollView>
    );
  }
}

Timeline.defaultProps = {
  theme: LightThemeColors,
  currentPlan: {},
  currentPlanIconName: 'icMobile',
  renewableAddonIconName: 'icRefresh',
};
Timeline.propTypes = {
  data: PropTypes.array,
  images: PropTypes.object,
  onItemPress: PropTypes.func,
  currentPlanIconName: PropTypes.string,
  renewableAddonIconName: PropTypes.string,
  currentPlan: PropTypes.shape({
    name: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    currency: PropTypes.string,
  }),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isTimeLineRefreshed: PropTypes.bool,
};
export default withTheme(Timeline);
